import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
const GOAL_ATTAINMENT_COLORS = {
    good: { bg: '#ecfdf3', text: '#027a48', arrow: 'up' },
    warn: { bg: '#fffaeb', text: '#b54708', arrow: 'down' },
    bad: { bg: '#fef3f2', text: '#b42318', arrow: 'down' },
};
export const VarianceBadge = React.memo(({ value, label, favourable, bold, fontSize = '12px', fontWeight, goalAttainment, plain, neutral }) => {
    const isUp = value >= 0;
    const isPos = favourable ?? isUp;
    let bg = isPos ? '#ecfdf3' : '#fef3f2';
    let textColor = isPos ? '#027a48' : '#b42318';
    let arrowUp = isUp;
    if (neutral) {
        bg = '#fffaeb';
        textColor = '#b54708';
    }
    else if (goalAttainment) {
        const tier = value >= 100 ? GOAL_ATTAINMENT_COLORS.good
            : value >= 80 ? GOAL_ATTAINMENT_COLORS.warn
                : GOAL_ATTAINMENT_COLORS.bad;
        bg = tier.bg;
        textColor = tier.text;
        arrowUp = tier.arrow === 'up';
    }
    return (_jsxs(Box, { sx: {
            backgroundColor: plain ? 'transparent' : bg,
            borderRadius: plain ? 0 : '16px',
            px: plain ? 0 : 1,
            py: plain ? 0 : 0.5,
            display: 'inline-flex',
            alignItems: 'center',
            gap: plain ? 0.25 : 0.5,
        }, children: [_jsx(Typography, { className: "all-Font-Sizes", sx: {
                    fontFamily: "'Inter', sans-serif",
                    fontSize: `${fontSize} !important`,
                    fontWeight: fontWeight ?? (bold ? 700 : 500),
                    color: textColor,
                    whiteSpace: 'nowrap',
                }, children: label ??
                    `${Math.abs(value).toLocaleString('en-US', {
                        maximumFractionDigits: 0,
                    })}%` }), !neutral && (_jsx("img", { src: arrowUp ? '/assets/trend-up.svg' : '/assets/trending-down.svg', alt: "", style: plain ? { width: 12, height: 12 } : undefined }))] }));
});
export default VarianceBadge;
